import * as React from "react";
import {createElement as h, Fragment} from "react";
import {Link} from "react-router-dom";

import "./breadcrumbs.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {joinJsx}        from "@Common/react/join-jsx";
import {Chip}           from "@Common/ui-components/heavy/common/design2/chip/chip";

import {removeListingParams} from "../../listing-params";

export const Breadcrumbs = ({cat = null, sub = null, userCreated = false, folder = null, listSelected = null, mailingOnly = null}) => cs(
    consumeContext("apis"),
    consumeContext("themeScheme"),
    consumeContext("menus"),
    consumeContext("userLevels"),
    consumeContext("routerHistory"),
    ({apis, themeScheme, menus, userLevels, routerHistory}) => {
        const programName = sub && getProgramName(cat && cat.id, sub.id, menus);
        return (
            <div
                className="breadcrumbs-7d3"
                style={{color: themeScheme.coloredText}}
            >
                {menus && (
                    <>
                        {joinJsx(
                        [
                            {
                            label: "Home",
                                ...( cat || sub || userCreated ) && {
                                    to: "/",
                            },
                            },
                            cat && cat.name && !programName && {label: cat.name, to: cat.id && sub && `/cat/${cat.id}`, onClick: undefined},
                            sub && {label: programName || sub.name},
                            userCreated && {
                                label: 'My Templates',
                                ...( folder ) && {
                                    to: "/my-templates",
                                },
                                onClick: undefined
                            },
                            folder && {label: programName || folder.name},
                        ]
                            .filter(v => v)
                            .map(({label, to, onClick}, i) => (
                                <Fragment key={i}>
                                    {h(to ? Link : "span", {
                                        to,
                                        ...to && {
                                            "xd-qa-type":"link",
                                            "xd-qa-name":label
                                        },
                                        onClick
                                    }, label)}
                                    <span style={{margin:"0 5px"}}>\</span>
                                </Fragment>
                            )),
                        () => " "
                        )}

                        {listSelected?.value && (
                            <Chip
                                backgroundColor={themeScheme?.xpresso.menuBackgroundColor}
                                textColor={themeScheme?.xpresso.menuTextColor}
                                text={`Listing Selected: ${sessionStorage.getItem("listingStreetAddress")}`}
                                onClose={() => {
                                    removeListingParams();
                                    listSelected.onChange(false)
                                    routerHistory?.push("/")
                                }}
                            />
                        )}
                        {mailingOnly?.value && (
                            <Chip
                                backgroundColor={themeScheme?.xpresso.menuBackgroundColor}
                                textColor={themeScheme?.xpresso.menuTextColor}
                                text="Showing Mailing Templates"
                                onClose={() => {
                                    sessionStorage.removeItem("mailingOnly");
                                    mailingOnly.onChange(false)
                                }}
                            />
                        )}

                        {userLevels?.listSelected && (
                            <Chip
                                backgroundColor={themeScheme?.xpresso.menuBackgroundColor}
                                textColor={themeScheme?.xpresso.menuTextColor}
                                text={`Recipient List Selected: ${userLevels.listName}`}
                                onClose={async () => {
                                    await apis.next.session.clearSessionOrder();
                                    routerHistory?.push("/")
                                    userLevels.reload();
                                }}
                            />
                        )}
                    </>
                )}
            </div>
        );
    }
);

const getProgramName = (catId, subId, menus) => {
    if (!catId || !subId || !menus) {
        return null;
    }

    for (let i = 0; i < menus.leftMenus.length; i++) {
        const leftMenu = menus.leftMenus[i];

        for (let j = 0; leftMenu.subMenu && j < leftMenu.subMenu.length; j++) {
            const subMenu = leftMenu.subMenu[j];
            if (subMenu.link === `app/cat/${catId}/sub/${subId}`) {
                return subMenu.linkLabel;
            }
        }
    }
};
